import { createAction, props } from '@ngrx/store';
import { IRollbackPaymentRunRequest } from '../models/rollback-payment-run-request.model';
import { IRollbackPaymentRunResponse } from '../models/rollback-payment-run-response.model';

export const rollbackPaymentRun = createAction(
  '[Payment Run] Rollback Payment Run',
  props<{
    request: IRollbackPaymentRunRequest;
  }>()
);

export const rollbackPaymentRunSuccess = createAction(
  '[Payment Run] Rollback Payment Run Success',
  props<{ response: IRollbackPaymentRunResponse }>()
);

export const rollbackPaymentRunFailure = createAction(
  '[Payment Run] Rollback Payment Run Failure',
  props<{ error: Error | any }>()
);
